import { decryptAES, encryptAES } from "../../Common/Axios/encrypt";
import API from "../../Common/Endpoint/serviceConstrants";
import { onSavePoints } from "../../Store/Slices/cardDataSlice";
import { onPostEarnPointSubmit } from "../../Store/Slices/earnPointSlice";
import { onGenerateTokenSubmit } from "../../Store/Slices/generateTokenSlice";
import { onGetMember } from "../../Store/Slices/getMemberSlice";
import { onPostRedeemPoints } from "../../Store/Slices/redeemPointsSlice";
import { onPostSendMail } from "../../Store/Slices/sendMailSlice";
import {
  onAllSmsSentSuccess,
  onPostSendSmsSubmit,
} from "../../Store/Slices/sendSmsSlice";
import { onPostSwitchAccount } from "../../Store/Slices/switchAccountSlice";
import { onPostUrlData } from "../../Store/Slices/urlStoreSlice";
import { onPostVendorOrder } from "../../Store/Slices/vendorOrderSlice";
import {
  ClientConfigurationData,
  formatPrice,
  GetCurrentDateTime,
  getImageUrl,
  ParseInt,
} from "../Utility/Utility";

const handleGenerateToken = (dispatch, v3Data) => {
  dispatch(
    onGenerateTokenSubmit({
      accessKey: v3Data?.accessKey,
      secrateKey: v3Data?.secrateKey,
      partnerCode: v3Data?.partnerCode,
      ClientCode: v3Data?.ClientCode,
    }),
  );
};
const handleGetMember = (dispatch, loginV3Data, v3Data) => {
  dispatch(
    onGetMember({
      memberIdentifier: loginV3Data?.memberIdentifier,
      ClientCode: v3Data?.ClientCode,
      partnerCode: v3Data?.partnerCode,
    }),
  );
};

const callSwitchAccountApi = (dispatch, loginToken, v3Data) => {
  const switchPayload = {
    identifier: loginToken?.memberIdentifier,
    subIdentifier: loginToken?.subIdentifier || "",
    identifierType: 1001,
    userSessionToken: sessionStorage.getItem("loginSessionToken"),
    isAccountSwitch: false,
    ClientCode: v3Data?.ClientCode,
    partnerCode: v3Data?.partnerCode,
  };
  dispatch(onPostSwitchAccount(switchPayload));
};

const handleEarnPoints = (
  dispatch,
  loginV3Data,
  v3Data,
  productReducer,
  orderData,
  totalPayableAmount,
  earnPoints,
  totalQuantity,
  generateToken,
  axiosIntegration,
) => {
  const payload = {
    ClientCode: v3Data?.ClientCode,
    partnerCode: v3Data?.partnerCode,
    culture: 1,
    transactionNo: orderData?.postOrderData?.[0]?.orderId,
    memberIdentifier: loginV3Data.memberIdentifier,
    transactionDate: GetCurrentDateTime(),
    items: [
      {
        itemKey: "wallet",
        partnerCode: v3Data?.partnerCodeBody,
        shoppingAmount: totalPayableAmount,
        rewardAmount: totalPayableAmount,
        pointToEarn: ParseInt(earnPoints),
        quantity: totalQuantity,
        itemAttribute: {
          TransactionType: "Gift Cards",
          TransactionSubType: "E-22commerce",
          TransactionBrand: productReducer?.productReducer?.name,
          TransactionProduct: productReducer?.productReducer?.name,
          TransactionSKU: "EGCGBAM22ZB2BRS001",
          TransactionSeller: "Qw22ick Cilver",
          SubOrderNumber: orderData?.postOrderData?.[0]?.orderNumber,
          TransactionMRP: totalPayableAmount.toString(),
          TransactionTax: "0",
          pgCardNo: "",
          pgAuthCode: "",
          MobileNo: loginV3Data?.memberProfile?.mobileNumber,
          MasterCode: "",
        },
        subItems: [],
      },
    ],
  };
  axiosIntegration.defaults.headers["access-token"] =
    `${generateToken?.data?.accessToken}`;
  dispatch(onPostEarnPointSubmit(payload));
};
const handlePointsUpdate = (dispatch, memberData) => {
  dispatch(
    onSavePoints({
      pointBalance: memberData?.pointBalance,
    }),
  );
};
const handleShortURL = (dispatch, orderData, memberData, productList) => {
  productList.forEach((prod) => {
    var enc = encryptAES(
      `email=true&orderId=${orderData?.postOrderData?.[0]?.orderNumber}&denomination=${prod.denomination}&memberId=${memberData?.MemberData?.memberProfile?.pointBalance}`,
    );
    var finalUrl = `${window.location.origin}/${ClientConfigurationData?.otpRedeem ? "otp" : "order-detail"
      }?${enc}`;
    dispatch(
      onPostUrlData({
        longUrl: finalUrl,
        otp: enc,
        orderId: orderData?.postOrderData?.[0]?.orderNumber,
        denomination: prod.denomination,
      }),
    );
  });
};

// const handleSendSms = (
//   dispatch,
//   orderDetails,
//   loginV3Data,
//   V3Data,
//   cardName,
// ) => {
//   if (orderDetails?.length) {
//     orderDetails.forEach((item) => {
//       const { quantity, denomination } = item;

//       const payload = {
//         ClientCode: V3Data?.ClientCode,
//         partnerCode: V3Data?.partnerCode,
//         templateCode: V3Data?.smsCode,
//         toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
//         contentValue: null,
//         content: `Congrats! You’ve ordered ${quantity} ${cardName} worth ₹${denomination} from Bank of Maharashtra Giftstacc! Access here: https://bankofmaharashtra.giftstacc.com/otp?9534. T%26C: https://bankofmaharashtra.giftstacc.com/listing – CustCap`,
//       };

//       dispatch(onPostSendSmsSubmit(payload));
//     });
//   } else {
//     const payload = {
//       ClientCode: V3Data?.ClientCode,
//       partnerCode: V3Data?.partnerCode,
//       templateCode: V3Data?.smsCode,
//       toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
//       contentValue: null,
//       content: `Congrats! You’ve ordered ${orderDetails?.qty} ${cardName} worth ₹${orderDetails?.denomination} from Bank of Maharashtra Giftstacc! Access here: https://bankofmaharashtra.giftstacc.com/otp?9534. T%26C: https://bankofmaharashtra.giftstacc.com/listing – CustCap`,
//     };
//     dispatch(onPostSendSmsSubmit(payload));
//   }
// };

const handleSendSms = (
  dispatch,
  orderDetails,
  loginV3Data,
  V3Data,
  cardName,
  smsTemplate,
  orderData,
) => {
  if (!smsTemplate?.smsBody) return;

  if (orderDetails?.length) {
    for (var o = 0; o < orderDetails.length; o++) {
      const giftCode = orderDetails[o]?.giftCode
        ? decryptAES(orderDetails[o]?.giftCode)
        : [];

      // Prepare base template once per order
      var baseTemplate = smsTemplate.smsBody;

      baseTemplate = baseTemplate?.replace(
        "{%memberName%}",
        `${loginV3Data?.memberProfile?.firstName || ""} ${loginV3Data?.memberProfile?.lastName || ""}`,
      );

      baseTemplate = baseTemplate?.replace(
        "{%orderId%}",
        orderData?.orderId || "",
      );

      baseTemplate = baseTemplate?.replace("{%voucherName%}", cardName || "");

      // Use FOR loop as you want
      for (var i = 0; i < giftCode.length; i++) {
        var dynamicdata = baseTemplate;

        dynamicdata = dynamicdata?.replace(
          "{%voucherValue%}",
          formatPrice(giftCode[i]?.Amount),
        );

        dynamicdata = dynamicdata?.replace(
          "{%voucherDate%}",
          new Date(giftCode[i]?.Validity)
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })?.replace(/ /g, " "),
        );

        var pinLabel = giftCode[i]?.labels?.cardPin;
        var numberLabel = giftCode[i]?.labels?.cardNumber;

        const cardNumber = giftCode[i]?.CardNumber
          ? `\n${numberLabel} ${giftCode[i].CardNumber}`
          : "";

        const cardPin = giftCode[i]?.CardPin
          ? `\n${pinLabel} ${giftCode[i].CardPin}`
          : "";

        dynamicdata = dynamicdata?.replace("{%voucherPin%}", cardPin || "");
        dynamicdata = dynamicdata?.replace("{%voucherCode%}", cardNumber || "");

        const payload = {
          ClientCode: V3Data?.ClientCode,
          partnerCode: V3Data?.partnerCode,
          templateCode: smsTemplate?.tempCode,
          toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
          contentValue: {
            additionalProp1: "string",
          },
          content: dynamicdata,
        };

        dispatch(onPostSendSmsSubmit(payload));
      }
    }
  } else {
    const giftCode = orderDetails?.giftCode
      ? decryptAES(orderDetails?.giftCode)
      : [];

    // Same logic for single order
    var baseTemplate = smsTemplate.smsBody;

    baseTemplate = baseTemplate?.replace(
      "{%memberName%}",
      `${loginV3Data?.memberProfile?.firstName || ""} ${loginV3Data?.memberProfile?.lastName || ""}`,
    );

    baseTemplate = baseTemplate?.replace(
      "{%orderId%}",
      orderData?.orderId || "",
    );

    baseTemplate = baseTemplate?.replace("{%voucherName%}", cardName || "");

    for (var i = 0; i < giftCode?.length; i++) {
      var dynamicdata = baseTemplate;

      dynamicdata = dynamicdata?.replace(
        "{%voucherValue%}",
        formatPrice(giftCode[i]?.Amount),
      );

      dynamicdata = dynamicdata?.replace(
        "{%voucherDate%}",
        new Date(giftCode[i]?.Validity)
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .replace(/ /g, " "),
      );

      var pinLabel = giftCode[i]?.labels?.cardPin;
      var numberLabel = giftCode[i]?.labels?.cardNumber;

      const cardNumber = giftCode[i]?.CardNumber
        ? `\n${numberLabel} ${giftCode[i].CardNumber}`
        : "";

      const cardPin = giftCode[i]?.CardPin
        ? `\n${pinLabel} ${giftCode[i].CardPin}`
        : "";

      dynamicdata = dynamicdata?.replace("{%voucherPin%}", cardPin || "");
      dynamicdata = dynamicdata?.replace("{%voucherCode%}", cardNumber || "");

      const payload = {
        ClientCode: V3Data?.ClientCode,
        partnerCode: V3Data?.partnerCode,
        templateCode: smsTemplate?.tempCode,
        toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
        contentValue: {
          additionalProp1: "string",
        },
        content: dynamicdata,
      };

      dispatch(onPostSendSmsSubmit(payload));
    }
  }
};

const handleRedeem = (
  dispatch,
  V3Data,
  loginV3Data,
  burnPoints,
  orderId,
  axiosIntegration,
  generateToken,
  totalPayableAmount,
  onlyCash,
  cashPlusPoints,
  totalPaid,
  category,
  sku
) => {
  axiosIntegration.defaults.headers["access-token"] =
    `${generateToken?.data?.accessToken}`;
  axiosIntegration.defaults.headers["ClientCode"] = `${V3Data.ClientCode}`;
  axiosIntegration.defaults.headers["PartnerCode"] = `${V3Data.partnerCode}`;
  const payload = {
    culture: 1,
    partnerCode: V3Data?.partnerCodeBody,
    transactionNo: orderId,
    memberIdentifier: loginV3Data.memberIdentifier,
    transactionDate: GetCurrentDateTime(),
    amountToRedeem:totalPaid - totalPayableAmount,
    itemAttribute: {
      Name:
        loginV3Data?.memberProfile?.firstName +
        " " +
        loginV3Data?.memberProfile?.lastName,
      IsOffline: "false",
      EmailID: loginV3Data?.memberProfile?.emailId,
      MobileNo: loginV3Data?.memberProfile?.mobileNumber,
      CategoryFlag: "Gift Cards",
      PointValue:(totalPaid - totalPayableAmount).toString(),
      ItemDetails: V3Data?.OrderData?.name,
      MerchantName: V3Data?.OrderData?.name,
      AmountToRedeem: (totalPaid - totalPayableAmount).toString(),
      PerPointValue: ((totalPaid - totalPayableAmount) / burnPoints)
        .toFixed(2)
        .toString(),
      Description: V3Data?.OrderData?.name,
      PlatformCode: "Giftstacc",
      RedemptionCategory: category,
      Narration: V3Data?.OrderData?.name,
      CashContribution: totalPayableAmount.toString(),
      SKU: sku,
      PaymentMode: onlyCash
        ? "Cash"
        : cashPlusPoints
          ? "Cash + Points"
          : "Only Points",
      Items: JSON.stringify(V3Data?.OrderData?.orderItems),      
      OrderValue:totalPaid.toString(),
    },
    pointsToRedeem: [
      {
        // shoppingAmount: totalPaid,
        point: burnPoints,
        integrationPartnerCode: V3Data?.integrationPartnerCode,
      },
    ],
    redemptionPartnerCode: V3Data?.redemptionPartnerCode,
    };
    dispatch(onPostRedeemPoints(payload));
};
function getTNCById(id, type = "tncContent", clientProduct) {
  const item = clientProduct?.find((entry) => entry.id === id);
  return item ? item[type] : null;
}
const replacePlaceholders = (template, replacements) => {
  return template.replace(/{{(.*?)}}/g, (_, key) => replacements[key]);
};
const cleanHTML = (htmlString) => {
  return htmlString?.replace(/\s+/g, " ")?.replace(/"/g, "'")?.trim();
};
const dynamicChildEmail = (
  payloadData,
  templateChild,
  clientDataReducer,
  clientConfigurationData,
) => {
  if (clientDataReducer?.otpConfig === 2) {
    let dynamicChild = templateChild;
    let dynamicChildData = "";
    dynamicChildData += dynamicChild.replace("{%qty%}", payloadData.qty);
    dynamicChildData = dynamicChildData.replace(
      "{%denomination%}",
      payloadData.denomination,
    );
    dynamicChildData = dynamicChildData.replace(
      "{%voucherValue%}",
      payloadData.customerDis * payloadData.qty,
    );

    var enc = encryptAES(
      `email=true&orderId=${payloadData?.orderId}&denomination=${payloadData.denomination}&memberId=${payloadData?.mobile}`,
    );
    dynamicChildData = dynamicChildData.replace(
      "{%retrieveCode%}",
      `${window.location.origin}/${clientConfigurationData?.otpRedeem ? "otp" : "order-detail"
      }?${enc}`,
    );
    return dynamicChildData;
  }
};
const dynamicEmail = (
  htmlString,
  product,
  templateChild,
  order,
  v3LoginData,
  clientDataReducer,
  clientConfigurationData,
  clientProduct,
) => {
  const totalItemAmount = order?.products?.reduce(
    (sum, item) => sum + item.customerDis * item.qty,
    0,
  );
  let htmlStringData = htmlString;
  htmlStringData = htmlStringData?.replace(
    "{%memberName%}",
    `${v3LoginData?.memberProfile?.firstName} ${v3LoginData?.memberProfile?.lastName}`,
  );
  htmlStringData = htmlStringData.replace("{%orderId%}", order?.orderId);
  const productImage =
    getImageUrl(product?.image) ||
    "https://d16lf5hy7u28ft.cloudfront.net/ClientB/img/default.png";

  htmlStringData = htmlStringData.replace("{%productUrl%}", productImage);
  htmlStringData = htmlStringData.replace(
    "{%redeemLink%}",
    `${window.location.origin}/tnc?productId=${product?.clientCommission}&orderId=${order?.orderId}`,
  );
  htmlStringData = htmlStringData.replace("{%voucherName%}", product?.name);
  var tncData = getTNCById(product.clientCommission, clientProduct);
  htmlStringData = htmlStringData.replace("{%TNC%}", cleanHTML(tncData));
  htmlStringData = htmlStringData.replace(
    "{%mobNo%}",
    clientConfigurationData?.phoneNumber,
  );
  htmlStringData = htmlStringData.replace("{%totalAmt%}", totalItemAmount);
  // Convenience Fee conditional logic
  if (order?.convenienceFee > 0) {
    htmlStringData = htmlStringData.replace(
      /{{#ifConvenienceFee}}([\s\S]*?){{\/ifConvenienceFee}}/,
      (_, blockContent) =>
        blockContent.replace("{%gstConv%}", order.convenienceFee),
    );
  } else {
    htmlStringData = htmlStringData.replace(
      /{{#ifConvenienceFee}}[\s\S]*?{{\/ifConvenienceFee}}/,
      "",
    );
  }

  htmlStringData = htmlStringData.replace(
    "{%ptsRedeem%}",
    Math.round(order.totalBurn),
  );
  htmlStringData = htmlStringData.replace("{%cashPaid%}", order.amount);
  let childData = dynamicChildEmail(
    product,
    templateChild,
    clientDataReducer,
    clientConfigurationData,
  );
  htmlStringData = htmlStringData.replace("{%child%}", childData);
  return htmlStringData;
};
const fetchEmailTemplate = async (
  data,
  product,
  order,
  v3LoginData,
  clientDataReducer,
  clientConfigurationData,
  clientProduct,
) => {
  let template = cleanHTML(data?.mailBody);
  let templateChild = cleanHTML(data?.mailBodyChild);
  template = dynamicEmail(
    template,
    product,
    templateChild,
    order,
    v3LoginData,
    clientDataReducer,
    clientConfigurationData,
    clientProduct,
  );
  return template;
};

const handleSendMail = (
  dispatch,
  sendMailData,
  v3LoginData,
  product,
  order,
  clientDataReducer,
  clientConfigurationData,
  clientProduct,
) => {
  const template = fetchEmailTemplate(
    sendMailData?.getMailData?.[0],
    product,
    order,
    v3LoginData,
    clientDataReducer,
    clientConfigurationData,
    clientProduct,
  );
  const htmlContent = replacePlaceholders(template, {});
  const mailPayload = {
    toEmailId: v3LoginData?.memberProfile?.emailId,
    templateCode: sendMailData?.getMailData?.[0]?.tempCode,
    content: htmlContent,
    subject: sendMailData?.getMailData?.[0]?.subject,
    contentValue: {
      UserName: "",
    },
  };
  dispatch(onPostSendMail(mailPayload));
};

const replaceTermsAndConditions = (htmlTemplate, tncContent) => {
  let tncClean = tncContent?.replaceAll(/"/g, "'");
  let htmlStringData = htmlTemplate;
  if (tncContent) {
    htmlStringData = htmlStringData.replace("{#tncRemove}", "");
    htmlStringData = htmlStringData.replace("{/tncRemove}", "");
    let tnc = cleanHTML(tncClean);
    htmlStringData = htmlStringData.replace("{%tncContent%}", tnc);
  } else {
    htmlStringData = htmlStringData.replace(
      /{#tncRemove}[\s\S]*?{\/tncRemove}/,
      "",
    );
    htmlStringData = htmlStringData.replace("{#tncRemove}", "");
    htmlStringData = htmlStringData.replace("{/tncRemove}", "");
  }
  return htmlStringData;
};

const dynamicFailureMail = (
  template,
  v3LoginData,
  order,
  product,
  childMailBody,
  orderDetails,
) => {
  let htmldata = template;
  let childHtml = childMailBody;
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}/${String(
    today.getMonth() + 1,
  ).padStart(2, "0")}/${today.getFullYear()}`;
  htmldata = htmldata.replace(
    "{%memberName%}",
    `${v3LoginData?.memberProfile?.firstName || ""} ${v3LoginData?.memberProfile?.lastName || ""
    }`,
  );
  htmldata = htmldata.replace("{%orderId%}", order?.orderId || "");
  htmldata = htmldata.replace("{%voucherName%}", product?.name || "");
  const productImage =
    getImageUrl(product?.image) ||
    "https://dpjvnq3sbpndh.cloudfront.net/email-images/fallbackimg_giftcard.png";

  htmldata = htmldata.replace("{%productUrl%}", productImage);

  htmldata = replaceTermsAndConditions(htmldata, orderDetails?.tncContent);

  childHtml = childHtml.replace("{%orderDate%}", formattedDate);
  childHtml = childHtml.replace("{%voucherName%}", product?.name || "");
  childHtml = childHtml.replace("{%orderId%}", order?.orderId || "");
  let cashPtsValue = "";

  if (order?.totalBurn === 0) {
    cashPtsValue = `₹ ${order?.amount || ""}`;
  } else if (order?.amount === 0) {
    cashPtsValue = `${Math.round(order?.totalBurn || 0)} pts`;
  } else {
    cashPtsValue = `₹ ${order?.amount || ""} + ${Math.round(order?.totalBurn || 0)} pts`;
  }
  childHtml = childHtml.replace("{%cashPts%}", cashPtsValue);
  htmldata = htmldata.replace("{%child%}", childHtml || "");

  return htmldata;
};

const handleFailureMail = (
  dispatch,
  sendMailData,
  v3LoginData,
  product,
  order,
  clientInfo,
  clientConfig,
  orderDetails,
) => {
  const failedMail = sendMailData?.getMailData?.find(
    (item) =>
      item?.emailType === "Failed" &&
      item?.enabled &&
      item?.eventType === "email",
  );
  let template = cleanHTML(failedMail?.mailBody);
  let childTemplate = cleanHTML(failedMail?.mailBodyChild);
  let content = dynamicFailureMail(
    template,
    v3LoginData,
    order,
    product,
    childTemplate,
    orderDetails,
  );

  let subject = failedMail?.subject;
  subject = subject?.replace("{%voucherName%}", product?.name);

  let htmlContent = replacePlaceholders(content, {});
  htmlContent = htmlContent?.replace(/\\r\\n|\\n|\\r/g, "");
  htmlContent = htmlContent.replaceAll("\\", "");

  const mailPayload = {
    toEmailId: v3LoginData?.memberProfile?.emailId,
    templateCode: failedMail?.tempCode,
    subject: subject,
    content: htmlContent,
    contentValue: {
      UserName: v3LoginData?.memberProfile?.firstName || "",
    },
  };
  dispatch(onPostSendMail(mailPayload));
};

const dynamicAdminFailureMail = (
  template,
  order,
  product,
  vendorResponse,
  supplierName,
) => {
  let htmldata = template;
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}/${String(
    today.getMonth() + 1,
  ).padStart(2, "0")}/${today.getFullYear()}`;
  htmldata = htmldata?.replace("{%OrderId%}", order?.orderId || "");
  htmldata = htmldata?.replace("{%VoucherName%}", product?.name || "");
  htmldata = htmldata?.replace("{%Amount%}", `${order?.amount ?? ""}`);
  htmldata = htmldata?.replace("{%OrderDate%}", formattedDate);
  htmldata = htmldata?.replace("{%Supplier%}", supplierName);
  htmldata = htmldata?.replace("{%FailureReason%}", vendorResponse || "");
  htmldata = htmldata?.replace("{%DenominationsOrdered%}", order?.products?.map((p) => p.denomination).join(", ") || "");
  htmldata = htmldata?.replace("{%ErrorMessage%}", vendorResponse || "");
  return htmldata;
};

const sendFailureMailToAdmin = (
  dispatch,
  sendMailData,
  product,
  order,
  adminEmail,
  vendorResponse,
  supplierName,
  v3LoginData
) => {
  const failedMail = sendMailData?.getMailData?.find(
    (item) =>
      item?.emailType === "AdminFailed" &&
      item?.enabled &&
      item?.eventType === "email",
  );
  let template = cleanHTML(failedMail?.mailBody);
  let content = dynamicAdminFailureMail(
    template,
    order,
    product,
    vendorResponse,
    supplierName
  );

  let subject = failedMail?.subject;

  subject = subject?.replace("{%VoucherName%}", product?.name);
  subject = subject?.replace("{%OrderId%}", order?.orderId);

  let htmlContent = replacePlaceholders(content, {});
  htmlContent = htmlContent?.replace(/\\r\\n|\\n|\\r/g, "");
  htmlContent = htmlContent?.replaceAll("\\", "");

  const mailPayload = {
    toEmailId: adminEmail,
    templateCode: failedMail?.tempCode,
    subject: subject,
    content: htmlContent,
    contentValue: {
      UserName: v3LoginData?.memberProfile?.firstName || "",
    },
  };
  dispatch(onPostSendMail(mailPayload));
};

const dynamicFailureSms = (template, order, loginV3Data, product) => {
  let htmldata = template;
  htmldata = htmldata?.replace(
    "{%memberName%}",
    `${loginV3Data?.memberProfile?.firstName || ""} ${loginV3Data?.memberProfile?.lastName || ""
    }`,
  );
  htmldata = htmldata?.replace("{%orderId%}", order?.orderId || "");
  htmldata = htmldata?.replace("{%voucherName%}", product?.name || "");
  return htmldata;
};

const dynamicProcessingSms = (template, orderId, loginV3Data, orderData) => {
  let htmldata = template;
  htmldata = htmldata?.replace(
    "{%memberName%}",
    `${loginV3Data?.memberProfile?.firstName || ""} ${loginV3Data?.memberProfile?.lastName || ""
    }`,
  );
  htmldata = htmldata?.replace("{%orderId%}", orderId || "");
  htmldata = htmldata?.replace(
    "{%voucherName%}",
    orderData?.products?.[0]?.name || "",
  );
  htmldata = htmldata?.replace("{%voucherValue%}", orderData?.totalAmount || "");
  return htmldata;
};

const handleFailureSms = async (
  dispatch,
  sendSmsState,
  v3Data,
  loginV3Data,
  order,
  product,
) => {
  const failedSms = sendSmsState?.getMailData?.find(
    (item) =>
      item.emailType === "Failed" && item.eventType === "sms" && item.enabled,
  );
  let template = failedSms?.smsBody;
  const smsContent = dynamicFailureSms(template, order, loginV3Data, product);
  const payload = {
    ClientCode: v3Data?.ClientCode,
    partnerCode: v3Data?.partnerCode,
    templateCode: failedSms?.tempCode,
    toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
    contentValue: {
      UserName: loginV3Data?.memberProfile?.firstName || "",
    },
    content: smsContent,
  };
  dispatch(onPostSendSmsSubmit(payload));
};

const handleProcessingSms = async (
  dispatch,
  sendSmsState,
  v3Data,
  loginV3Data,
  orderId,
  orderData,
) => {
  const processingSms = sendSmsState?.getMailData?.find(
    (item) =>
      item.emailType === "Processing" &&
      item.eventType === "sms" &&
      item.enabled,
  );
  let template = processingSms?.smsBody;
  const smsContent = dynamicProcessingSms(
    template,
    orderId,
    loginV3Data,
    orderData,
  );
  const payload = {
    ClientCode: v3Data?.ClientCode,
    partnerCode: v3Data?.partnerCode,
    templateCode: processingSms?.tempCode,
    toMobileNumber: loginV3Data?.memberProfile?.mobileNumber,
    contentValue: {
      UserName: loginV3Data?.memberProfile?.firstName || "",
    },
    content: smsContent,
  };
  dispatch(onPostSendSmsSubmit(payload));
};
const handleVedorOrder = (dispatch, payload) => {
  dispatch(onPostVendorOrder(payload));
};

const shortUrlSendSms = async (
  dispatch,
  productList,
  orderData,
  memberData,
  clientConfig,
  axiosInstanceClient,
  v3Data,
  loginV3Data,
  productReducer,
  navigate,
  setLoading,
) => {
  setLoading(true);
  try {
    const responses = await Promise.allSettled(
      productList.map(async (prod) => {
        const enc = encryptAES(
          `email=true&orderId=${orderData?.postOrderData?.[0]?.orderid}&denomination=${prod.denomination}&memberId=${memberData?.MemberData?.memberProfile?.pointBalance}`,
        );

        const longUrl = `${window.location.origin}/${clientConfig?.otpRedeem ? "otp" : "order-detail"
          }?${enc}`;

        const payload = {
          longUrl,
          otp: enc,
          orderId: orderData?.postOrderData?.[0]?.orderNumber,
          denomination: prod.denomination,
        };

        const response = await axiosInstanceClient.post(API.manageUrl, payload);

        return {
          ...prod,
          shortUrl: response.data?.response?.[0]?.shortUrl || longUrl,
          fallbackUrl: longUrl,
        };
      }),
    );

    responses.forEach((result, index) => {
      const prod = productList[index];
      const enc = encryptAES(
        `email=true&orderId=${orderData?.postOrderData?.[0]?.orderId}&denomination=${prod.denomination}&memberId=${memberData?.MemberData?.memberProfile?.pointBalance}`,
      );

      const longUrl = `${window.location.origin}/${clientConfig?.otpRedeem ? "otp" : "order-detail"
        }?${enc}`;

      const url =
        result.status === "fulfilled"
          ? result.value.shortUrl || longUrl
          : longUrl;

      const payload = {
        ClientCode: v3Data?.ClientCode,
        partnerCode: v3Data?.partnerCode,
        templateCode: "BOMORDCONF01 ",
        toMobileNumber: loginV3Data.mobileNumber,
        contentValue: null,
        content: `Congrats! You’ve ordered ${prod.quantity} ${productReducer?.productReducer?.[0]?.name} worth ₹${prod.denomination} from Bank of Maharashtra Giftstacc! Access here: ${url}. T&C: https://bankofmaharashtra.giftstacc.com/listing – CustCap`,
      };

      dispatch(onPostSendSmsSubmit(payload));
    });
  } catch (error) {
    console.error("Unexpected error during manageUrl execution:", error);
  } finally {
    dispatch(onAllSmsSentSuccess());
    navigate("/order-confirmation");
  }
};
export {
  handleGenerateToken,
  handleGetMember,
  handleEarnPoints,
  handlePointsUpdate,
  handleSendSms,
  handleRedeem,
  handleShortURL,
  handleSendMail,
  handleVedorOrder,
  shortUrlSendSms,
  handleFailureMail,
  callSwitchAccountApi,
  handleFailureSms,
  handleProcessingSms,
  sendFailureMailToAdmin,
};
